import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import './Detail.css'
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faExternalLinkAlt, faStar, faTrash, faHeart } from '@fortawesome/free-solid-svg-icons';
import whatsappIcon from '../../images/wpp.png';
import logoPlaceholder from '../../images/4.png';
import { Link as Anchor, useNavigate, useLocation } from "react-router-dom";
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import baseURL from '../url';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DetailLoading from "../DetailLoading/DetailLoading";
import moneda from '../moneda';
import Navbar from '../Navbar/Navbar';

// =========================================================================
// 🚨 CONFIGURACIÓN PARA EL CRM 🚨
// ESTOS EMAILS SON FIJOS Y NO CAMBIAN POR CONSULTA
// =========================================================================
const CRM_ADF_EMAIL = 'casilla@ejemplo.com'; // 🎯 Email FIJO de descarga de tu CRM (DESTINO)
const SENDER_EMAIL = 'tuemaildeenvio@ejemplo.com'; // 📧 Email FIJO que usa tu servidor para enviar (ORIGEN)
const VENDOR_NAME = 'R20 Concesionaria'; // 🏢 Nombre del concesionario/vendedor
const PROVIDER_NAME = 'R20 Web Oficial'; // 🌐 Origen de la consulta 
// =========================================================================

export default function Detail() {
    const navigate = useNavigate();
    const swiperRef = useRef(null);
    SwiperCore.use([Navigation, Pagination, Autoplay]);
    const { idProducto } = useParams();
    const [producto, setProducto] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState("");
    const [cantidad, setCantidad] = useState(1);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [contactos, setContactos] = useState([]);
    const [favoritos, setFavoritos] = useState([]);
    const items = [producto?.item1, producto?.item2, producto?.item3, producto?.item4, producto?.item5, producto?.item6, producto?.item7, producto?.item8, producto?.item9, producto?.item10];
    const [categorias, setCategorias] = useState([]);
    const [marcas, setMarcas] = useState([]);
    const [modelos, setModelos] = useState([]);
    const [selectedItemIndex, setSelectedItemIndex] = useState(0);
    const location = useLocation();

    // NUEVOS ESTADOS PARA EL FORMULARIO DE CONTACTO Y CRM
    const [isFormModalOpen, setIsFormModalOpen] = useState(false);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        city: '',
        comments: '',
    });

    // --- CARGA DE DATOS ---
    useEffect(() => {
        cargarProductos();
        cargarContacto();
        cargarFavoritos();
        cargarCategoria();
        cargarMarcas();
        cargarModelos();
        if (items.length > 0) {
            setSelectedItemIndex(0);
        }
    }, []);

    useEffect(() => {
        const product = productos.find((e) => e.idProducto === parseInt(idProducto));
        setProducto(product);
    }, [idProducto, productos]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // --- LÓGICA DE CARGA DE DATOS (Original) ---
    const handleSelectionChange = (index) => {
        setSelectedItemIndex(index);
    };

    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`, { method: 'GET', })
            .then(response => response.json())
            .then(data => { setCategorias(data.categorias || []); })
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const cargarMarcas = () => {
        fetch(`${baseURL}/marcasGet.php`, { method: 'GET', })
            .then(response => response.json())
            .then(data => { setMarcas(data.marca || []); })
            .catch(error => console.error('Error al cargar marcas:', error));
    };

    const cargarModelos = () => {
        fetch(`${baseURL}/modelosGet.php`, { method: 'GET', })
            .then(response => response.json())
            .then(data => { setModelos(data.modelos || []); })
            .catch(error => console.error('Error al cargar modelos:', error));
    };

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, { method: 'GET', })
            .then(response => response.json())
            .then(data => { setContactos(data.contacto.reverse()[0] || []); })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, { method: 'GET', })
            .then(response => response.json())
            .then(data => { setProductos(data.productos || []); setLoading(false); })
            .catch(error => { console.error('Error al cargar productos:', error); setLoading(true); });
    };

    const cargarFavoritos = () => {
        const storedFavoritos = JSON.parse(localStorage.getItem('favoritos')) || [];
        setFavoritos(storedFavoritos);
    };

    // --- MANEJO DE VISTAS Y ACCIONES (Original) ---
    function handleCompartirClick() {
        if (navigator.share) {
            navigator.share({
                title: document.title,
                text: 'Echa un vistazo a este producto',
                url: window.location.href,
            })
                .then(() => console.log('Contenido compartido correctamente'))
                .catch((error) => console.error('Error al compartir:', error));
        } else {
            console.error('La API de compartir no está disponible en este navegador.');
        }
    }

    const goBack = () => {
        if (location.key !== 'default') {
            navigate(-1);
        } else {
            navigate('/');
        }
    };

    const agregarAFavoritos = (idProducto) => {
        const favList = [...favoritos];
        const index = favList.indexOf(idProducto);
        if (index === -1) {
            favList.push(idProducto);
            setFavoritos(favList);
            localStorage.setItem('favoritos', JSON.stringify(favList));
            console.log('Producto agregado a favoritos');
        } else {
            favList.splice(index, 1);
            setFavoritos(favList);
            localStorage.setItem('favoritos', JSON.stringify(favList));
            console.log('Producto eliminado de favoritos');
        }
    };

    // --- LÓGICA DE INTEGRACIÓN CRM (ADF/WhatsApp) ---

    // 1. Abrir el modal del formulario
    const handleWhatsappClick = () => {
        setIsFormModalOpen(true);
    };

    // 2. Manejar cambios en el formulario
    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // 3. Generar el XML ADF
    const generateADF = () => {
        const now = new Date();
        const requestDate = `${now.getDate()}/${now.getMonth() + 1}/${now.getFullYear()} ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;

        // 🚨 FUNCIÓN SANITIZE CORREGIDA: Convierte a String para evitar el error .replace is not a function
        const sanitize = (value) => {
            const stringValue = String(value || '');

            return stringValue.replace(/[&<>"']/g, function (match) {
                const replacements = {
                    '&': '&amp;',
                    '<': '&lt;',
                    '>': '&gt;',
                    '"': '&quot;',
                    "'": '&apos;'
                };
                return replacements[match];
            });
        };
        // FIN FUNCIÓN SANITIZE CORREGIDA

        const vehicleMake = sanitize(marcas.find(m => m.idMarca === producto?.idMarca)?.nombre || '');
        const vehicleModel = sanitize(producto?.modelo || producto?.titulo || '');
        const vehicleYear = sanitize(producto?.anio);
        const productId = sanitize(producto?.idProducto);

        const xml = `<?ADF VERSION "1.0"?>
<adf>
<prospect>
<requestdate>${requestDate}</requestdate>
<vehicle>
<year>${vehicleYear}</year>
<make>${vehicleMake}</make>
<model>${vehicleModel}</model>
<comments>${sanitize(formData.comments || '')}</comments>
</vehicle>
<customer>
<contact>
<name part="first" type="individual">${sanitize(formData.firstName)}</name>
<name part="last" type="individual">${sanitize(formData.lastName)}</name>
<email preferredcontact="1">${sanitize(formData.email)}</email>
<phone type="phone">${sanitize(formData.phone)}</phone>
<phone type="cellphone"></phone>
<identification>${productId || 'N/A'}</identification>
<address type="home">
<city>${sanitize(formData.city)}</city>
</address>
</contact>
<comments>${sanitize(formData.comments || '')}</comments>
</customer>
<vendor>
<vendorname>${sanitize(VENDOR_NAME)}</vendorname>
</vendor>
<provider>
<name>${sanitize(PROVIDER_NAME)}</name>
<service></service>
</provider>
</prospect>
</adf>
`;
        return xml;
    };

    // 4. Enviar el Email ADF al backend
    const sendADFEmail = async (adfContent) => {
        const subject = `Consulta web - Vehículo: ${producto?.titulo || 'N/A'} (ID: ${producto?.idProducto})`;
        const cleanBaseURL = baseURL.endsWith('/') ? baseURL.slice(0, -1) : baseURL;
        try {
            // Se usa baseURL y la ruta fija del script PHP
            const response = await fetch(`${cleanBaseURL}/sendAdfEmail.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', },
                body: JSON.stringify({
                    to: CRM_ADF_EMAIL, // Email FIJO del CRM
                    from: SENDER_EMAIL, // Email FIJO de notificación
                    subject: subject,
                    body: adfContent,
                }),
            });

            const result = await response.json();

            if (response.ok && result.success) {
                console.log('ADF Email enviado con éxito al CRM.');
                return true;
            } else {
                console.error('Error al enviar el ADF Email:', result.message || 'Error desconocido.');
                toast.error('Error al enviar la consulta al CRM.');
                return false;
            }
        } catch (error) {
            console.error('Error de red al intentar enviar el ADF:', error);
            toast.error('Error de conexión al enviar la consulta.');
            return false;
        }
    };

    // 5. Manejar el envío final del formulario
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        // Validación simple
        if (!formData.firstName || !formData.phone || !formData.email) {
            toast.error('Por favor, completa los campos obligatorios (Nombre, Teléfono, Email).');
            return;
        }

        const adfContent = generateADF();

        // 5a. Enviar el ADF al CRM (esto sucede en background)
        await sendADFEmail(adfContent);

        // 5b. Continuar con el mensaje de WhatsApp 
        const phoneNumber = contactos?.telefono;
        const nombreConcesionaria = VENDOR_NAME;

        const datosVehiculo = [
            `*Vehículo:* ${producto?.titulo || 'No especificado'}`,
            producto?.anio && `*Año:* ${producto.anio}`,
            producto?.kilometros && `*Kilómetros:* ${producto.kilometros}`,
            producto?.transmision && `*Transmisión:* ${producto.transmision}`,
            producto?.combustible && `*Combustible:* ${producto.combustible}`,
            producto?.precio && `*Precio:* ${moneda} ${String(producto.precio).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`,
        ].filter(Boolean).join('\n');

        const message = `¡Hola, equipo de ${nombreConcesionaria}! 👋\n\nMi nombre es *${formData.firstName} ${formData.lastName}* y estoy interesado en el siguiente vehículo.\n\nAquí los detalles:\n${datosVehiculo}\n\n*Mi consulta:*\n${formData.comments || 'Sin comentarios adicionales.'}\n\nGracias, espero su pronta respuesta. 😊`;
        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

        setIsFormModalOpen(false); // Cierra el modal
        window.open(whatsappUrl, '_blank'); // Abre WhatsApp
        toast.success('Abriendo WhatsApp y enviando consulta al CRM...');
    };

    // --- DATOS AUXILIARES ---
    const categoriaNombre = categorias.find(cat => cat.idCategoria === producto?.idCategoria)?.categoria;
    const marcaNombre = marcas.find(marca => marca.idMarca === producto?.idMarca)?.nombre;

    const motoFields = {
        'engine': 'Motor', 'width': 'Ancho', 'cooling': 'Refrigeración', 'height': 'Altura',
        'fuel': 'Combustible', 'seatHeight': 'Altura de asiento', 'displacement': 'Cilindrada',
        'frontWheel': 'Rodado delantero', 'maxPower': 'Potencia máxima', 'rearWheel': 'Rodado trasero',
        'maxSpeed': 'Velocidad máxima', 'frontBrake': 'Freno delantero', 'rearBrake': 'Freno trasero',
        'starter': 'Arranque', 'tank': 'Tanque', 'weight': 'Peso', 'alarm': 'Alarma',
        'length': 'Largo', 'warranty': 'Garantía',
    };

    if (!producto || loading) {
        return <DetailLoading />;
    }

    // --- RENDERIZADO ---
    return (
        <div className="detail">
            <Navbar />
            <ToastContainer />
            <div className="deFlexDetail">
                <button className="back" onClick={goBack}> <FontAwesomeIcon icon={faArrowLeft} /> </button>
                <div className="deFLexIcon">
                    {/*<button onClick={() => agregarAFavoritos(producto.idProducto)} className='favoritos-btn'>
                        <FontAwesomeIcon icon={faHeart} style={{ color: favoritos.includes(producto.idProducto) ? 'red' : 'gray' }} />
                    </button>*/}
                    <button className="share" onClick={handleCompartirClick}> <FontAwesomeIcon icon={faExternalLinkAlt} /> </button>
                </div>
            </div>
            <div className="detail-contain">
                {/* SWIPER DE IMÁGENES */}
                <SwiperSlide id={"swiperDetail"} >
                    {(() => {
                        const imagenesProducto = [
                            { src: producto.imagen1, className: 'imagen1' },
                            { src: producto.imagen2, className: 'imagen2' },
                            { src: producto.imagen3, className: 'img' },
                            { src: producto.imagen4, className: 'imagen4' },
                            { src: producto.imagen5, className: 'imagen5' },
                        ].filter(img => img.src);

                        if (imagenesProducto.length === 0) {
                            // Sin imágenes: no inicializar Swiper (con 0 slides rompe al calcular clases)
                            // y mostrar un placeholder fijo en su lugar.
                            return (
                                <img
                                    src={logoPlaceholder}
                                    alt={producto.titulo}
                                    className="imagen1 sin-imagen-placeholder"
                                />
                            );
                        }

                        return (
                            <Swiper
                                effect={'coverflow'}
                                grabCursor={true}
                                loop={true}
                                slidesPerView={'auto'}
                                coverflowEffect={{ rotate: 0, stretch: 0, depth: 100, modifier: 2.5 }}
                                navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
                                autoplay={{ delay: 3000 }}
                                pagination={{ clickable: true, }}
                                onSwiper={(swiper) => {
                                    swiperRef.current = swiper;
                                }}
                            >
                                {imagenesProducto.map((img, index) => (
                                    <SwiperSlide key={index}>
                                        <img
                                            src={img.src}
                                            alt={producto.titulo}
                                            className={img.className}
                                            onClick={() => { setModalImage(img.src); setIsModalOpen(true); }}
                                        />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        );
                    })()}
                </SwiperSlide>

                <div className="textDetail">
                    <h2 className="title">{producto.titulo}</h2>
                    <hr />
                    <div className='price-section'>
                        {producto?.precioAnterior !== 0 && producto?.precioAnterior !== undefined && (
                            <h5 className='precio-tachado'>{moneda} {`${producto?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                        )}
                        <h5 className="price-current">
                            {moneda} {String(producto?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                        </h5>
                    </div>

                    {/* Sección de datos del vehículo */}
                    <div className="product-details-grid">
                        {categoriaNombre && <p><b>Categoría:</b> {categoriaNombre}</p>}
                        {marcaNombre && <p><b>Marca:</b> {marcaNombre}</p>}
                        {producto?.modelo && <p><b>Modelo:</b> {producto.modelo}</p>}
                        {producto?.anio && <p><b>Año:</b> {producto.anio}</p>}
                        {producto?.kilometros && <p><b>Kilómetros:</b> {producto.kilometros}</p>}
                        {producto?.transmision && <p><b>Transmisión:</b> {producto.transmision}</p>}
                        {producto?.combustible && <p><b>Combustible:</b> {producto.combustible}</p>}

                        {producto.isMotorcycle ? (
                            Object.entries(motoFields).map(([key, label]) => {
                                const value = producto[key];
                                if (!value) return null;
                                return (<p key={key}><b>{label}:</b> {value} </p>);
                            })
                        ) : null}
                    </div>

                    <p>{producto.descripcion}</p>
                    <div className='itemsDetail'>
                        {producto && items.length > 0 && items.map((item, index) => (
                            item && (
                                <label key={index}>
                                    <input
                                        type="radio"
                                        name="talle"
                                        value={item}
                                        checked={selectedItemIndex === index}
                                        onChange={() => handleSelectionChange(index)}
                                    />
                                    {item}
                                </label>
                            )
                        ))}
                    </div>
                    <div className='deFlexGoTocart'>
                        <button className="wpp" onClick={handleWhatsappClick}>
                            Consultar por WhatsApp
                            <img src={whatsappIcon} alt="whatsappIcon" />
                        </button>
                    </div>
                </div>
            </div>

            {/* Modal de Zoom de Imagen */}
            <Modal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                center
                classNames={{ modal: 'custom-modal', }}
            >
                <img src={modalImage} alt={producto.titulo} />
            </Modal>

            {/* 📝 MODAL DE FORMULARIO DE CONTACTO/CRM */}
            <Modal
                open={isFormModalOpen}
                onClose={() => setIsFormModalOpen(false)}
                center
                classNames={{ modal: 'form-modal', }}
            >
                <div className="form-container">
                    <h3>¡Consultá por **{producto?.titulo}**!</h3>
                    <p>Completa tus datos para enviar la consulta a un asesor y abrir WhatsApp.</p>
                    <form onSubmit={handleFormSubmit}>
                        <div className="form-group">
                            <label>Nombre *</label>
                            <input type="text" name="firstName" value={formData.firstName} onChange={handleFormChange} required />
                        </div>
                        <div className="form-group">
                            <label>Apellido</label>
                            <input type="text" name="lastName" value={formData.lastName} onChange={handleFormChange} />
                        </div>
                        <div className="form-group">
                            <label>Email *</label>
                            <input type="email" name="email" value={formData.email} onChange={handleFormChange} required />
                        </div>
                        <div className="form-group">
                            <label>Teléfono *</label>
                            <input type="tel" name="phone" value={formData.phone} onChange={handleFormChange} required />
                        </div>
                        <div className="form-group">
                            <label>Localidad</label>
                            <input type="text" name="city" value={formData.city} onChange={handleFormChange} />
                        </div>
                        <div className="form-group">
                            <label>Comentarios</label>
                            <textarea name="comments" value={formData.comments} onChange={handleFormChange} />
                        </div>
                        <button type="submit" className="submit-btn wpp">
                            Enviar Consulta y Abrir WhatsApp
                        </button>
                        <p className="required-note">* Campos obligatorios</p>
                    </form>
                </div>
            </Modal>
        </div>
    );
}